
import MainLayout from '@/layout/MainLayout.vue';
import { useAuthStore } from '@/store/AuthStore';
import { useGalleryStore } from '@/store/GalleriesStore';
import { defineComponent, nextTick } from 'vue';
import {
  MessagesData,
  Artwork,
  TheLastMessage,
  ConversationMessage,
  FirstParticipant,
  SecondParticipantClass,
} from '@/dataTypes/types';

export default defineComponent({
  components: { MainLayout },
  data() {
    const authStore = useAuthStore();
    const galleryStore = useGalleryStore();
    const id = this.$route.params.id;
    return {
      id,
      authStore,
      galleryStore,
      message: {} as MessagesData,
      artwork: {} as Artwork,
      lastMessage: {} as TheLastMessage,
      conversationMessages: [] as ConversationMessage[],
      createdAt: '',
      updatedAt: '',
      title: '',
      htmlTitle: '',
      firstParticipant: {} as FirstParticipant,
      secondParticipant: {} as SecondParticipantClass,
      messagetoSend: '',
      image: '',
      files: [] as string[],
      filesNames: [] as string[],
      isSending: false,
    };
  },
  async created() {
    if (this.authStore.isLoggedIn) await this.refreshConversation();
  },
  methods: {
    async refreshConversation() {
      this.message = await this.galleryStore.fetchMessageConversation(+this.id);
      this.artwork = this.message.artwork || ({} as Artwork);
      this.lastMessage = this.message.last_message || ({} as TheLastMessage);
      this.conversationMessages = this.message.conversation_messages || [];
      this.createdAt = this.message.created_at || '';
      this.updatedAt = this.message.updated_at || '';
      this.title = this.message.title || '';
      this.htmlTitle = this.message.html_title || '';
      this.firstParticipant =
        this.message.first_participant || ({} as FirstParticipant);
      this.secondParticipant =
        this.message.second_participant || ({} as SecondParticipantClass);
      this.image = this.artwork?.image?.original || '';
    },
    async sendMessage() {
      if (this.isSending) return;
      if (!this.messagetoSend?.trim() && this.files.length === 0) return;

      const files = this.files.map((file) => file);
      const message = {
        message: this.messagetoSend,
        files: files,
      };

      this.isSending = true;
      try {
        const req = await this.galleryStore.sendMessageToConversation(
          +this.id,
          message
        );

        // `sendMessageToConversation` returns the raw API response; treat any truthy success as a send.
        const success =
          (req && (req.success === true || req.message === 'success')) ||
          req?.data?.success === true ||
          req?.data?.message === 'success';

        if (success) {
          this.messagetoSend = '';
          this.files = [];
          this.filesNames = [];
          await this.refreshConversation();
          await nextTick();
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          });
        }
      } finally {
        this.isSending = false;
      }
    },
    onFileChange(e: File[] | Event | null) {
      const pickedFiles: File[] = Array.isArray(e)
        ? e
        : (() => {
            const target = (e?.target as HTMLInputElement | null) ?? null;
            return target?.files ? Array.from(target.files) : [];
          })();

      for (let i = 0; i < pickedFiles.length; i++) {
        const file = pickedFiles[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (reader.result !== null) {
            this.files.push(reader.result as string);
            this.filesNames.push(file.name);
          }
        };
      }
    },
  },
});
